import i18next from "i18next";
import { SaveRedux } from "./SaveRedux";
import { API_URL } from "../../config";
import axios from "axios";
import { store } from "../../AppSystem/Redux/Store";
import { logoutUser } from "../../AppSystem/Redux/Auth/AuthSlice";
import { jwtDecode } from "jwt-decode";
import { redirectWhenCloseSession } from "./RedirectWhenCloseSession";


let isRefreshing = false;
let refreshPromise = null;

const performTokenRefresh = async (currentRefreshTokenId, dispatch) => {
    try {
        const refreshConfig = { 
            withCredentials: true 
        };
        const response = await axios.get(
            `${API_URL}/application/admin/refresh-token?token=${currentRefreshTokenId}`,
            refreshConfig
        );

        if (response.data && response.data.token && response.data.refreshToken) {
            const newTokens = {
                token: response.data.token,
                refreshToken: response.data.refreshToken
            };
            
            SaveRedux(dispatch, 'tokenData', newTokens.token);
            SaveRedux(dispatch, 'refreshTokenData', newTokens.refreshToken);
            
            return newTokens;
        } else {
            throw new Error('Respuesta de refresco inválida');
        }
    } catch (error) {
        console.error('El refresco de token falló:', error);
        
        // ---
        // IF THE REFRESH FAILS, WE LOGOUT HERE
        // ---
        const { tokenData } = store.getState().auth; 
        const decodedToken = jwtDecode(tokenData);
        const loginMethod = decodedToken.loginMethod;

        if (loginMethod && loginMethod.toLowerCase() === 'lrfssoentraid') {
            // MSAL logic... (this is more complex, would require the instance)
            // msalInstance.logoutRedirect(...);
            dispatch(logoutUser());
        } else {
            dispatch(logoutUser());
            redirectWhenCloseSession(tokenData);
        }
        
        throw error;
    } finally {
        isRefreshing = false;
        refreshPromise = null;
    }
};

const getRefreshedToken = (currentRefreshTokenId, dispatch) => {
    if (!isRefreshing) {
        isRefreshing = true;
        refreshPromise = performTokenRefresh(currentRefreshTokenId, dispatch);
    }
    return refreshPromise;
};

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

// ---
// PETITION INTERCEPTOR (Request)
// ---
api.interceptors.request.use(
    (config) => {
        const { tokenData } = store.getState().auth;
        
        if (tokenData) {
            config.headers['Authorization'] = `Bearer ${tokenData}`;
        }
        config.headers['Accept-Language'] = i18next.language || 'en-US';
        
        return config;
    },
    (error) => Promise.reject(error)
);

// ---
// RESPONSE INTERCEPTOR (Response)
// ---
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        const { refreshTokenData } = store.getState().auth;
        const dispatch = store.dispatch;

        // If the error is 401 and it is NOT a retry
        if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
            originalRequest._retry = true; // We mark as retry

            if (!refreshTokenData || !refreshTokenData.id) {
                // No refresh token, we can't do anything
                return Promise.reject(error);
            }

            try {
                // We call your refresh function
                const newTokens = await getRefreshedToken(refreshTokenData.id, dispatch);

                // We update the original request headers
                originalRequest.headers['Authorization'] = `Bearer ${newTokens.token}`;

                // We retry the original request
                return api(originalRequest);

            } catch (refreshError) {
                // The logout has already been handled within performTokenRefresh
                return Promise.reject(refreshError);
            }
        }

        // For any other error (500, 404, etc.)
        return Promise.reject(error);
    }
);

export default api;